import type { FC, PropsWithChildren } from 'react'
import { IconButton, type IconButtonProps, Stack } from '@mui/material'
import { Close } from '@dhl/icons'

type DialogTitleClosableProps = {
  onClose?: IconButtonProps['onClick']
  closeSize?: 'inherit' | 'large' | 'medium' | 'small'
  px?: number
  py?: number
  disabled?: boolean
}

export const DialogTitleClosable: FC<PropsWithChildren<DialogTitleClosableProps>> = ({
  onClose,
  children,
  closeSize = 'inherit',
  px = 2,
  py = 1,
  disabled = false,
}) => (
  <Stack flexDirection="row" justifyContent="space-between" alignItems="center" px={px} py={py}>
    {children}
    {onClose && (
      <IconButton
        data-test="dialog-title-closable"
        sx={{ marginLeft: 'auto', marginRight: '-10px', zIndex: 1 }}
        onClick={onClose}
        disabled={disabled}
      >
        <Close fontSize={closeSize} />
      </IconButton>
    )}
  </Stack>
)
